import script from "./RenewNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewNotice.vue?vue&type=script&setup=true&lang=js"

import "./RenewNotice.vue?vue&type=style&index=0&id=626f49e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626f49e4"]])

export default __exports__